import React, { ReactNode } from "react";

type ActionProps = {
  onClick?: any;
  icon: ReactNode;
  className?: string;
  label?: string;
};

const ActionButton = (props: ActionProps) => {
  return (
    <div className={`action-button ${props.className ?? ""}`} onClick={props.onClick}>
      <div className="action-button-icon">{props.icon}</div>
      {props.label && <div className="action-button-label">{props.label}</div>}
    </div>
  );
};

export default ActionButton;
